import { useEffect, useState } from 'react';
import { removeSessionCookies } from 'components/sessionTimeOut/utils/removeSessionCookies';
import { SESSION_STATUS } from 'components/sessionTimeOut/constants';

export const useOverWrittenModalCheck = ({ session, onOverWrittenModalOpen, modalCancelActions, stepsActions }) => {
    const [{ showOverWrittenModal, overwrittenBlowupClass }, setOverWrittenModalConfig] = useState(false);

    const openOverWrittenModal = () => {
        stepsActions.hideWelcomeCard();
        modalCancelActions.hideModalCancel();
        onOverWrittenModalOpen();
        setOverWrittenModalConfig(prevState => ({
            ...prevState,
            showOverWrittenModal: true,
            overwrittenBlowupClass: 'blowup-modal blowup-in',
        }));

        removeSessionCookies();
    };

    const closeOverWrittenModal = () => {
        setOverWrittenModalConfig(prevState => ({
            ...prevState,
            showOverWrittenModal: false,
            overwrittenBlowupClass: 'blowup-modal blowup-out',
        }));
    };

    const checkOverrittenModalCondition = () => {
        const sessionStatus = session.get('sessionStatus');
        const status = sessionStatus.get('status');
        const closed = sessionStatus.get('closed');
        const overwrittenCondition = status === SESSION_STATUS.OVERWRITTEN || closed;

        overwrittenCondition && !showOverWrittenModal && openOverWrittenModal();
    };

    useEffect(() => {
        checkOverrittenModalCondition();
    }, [session]);

    return { showOverWrittenModal, overwrittenBlowupClass, openOverWrittenModal, closeOverWrittenModal };
};
